import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Redirect a renamed route, keeping the query string and hash so deep links still land on the
 * same filter or record (e.g. /approvals?formId=123 -> /submissions?formId=123).
 */
const RedirectPreservingQuery: React.FC<{
  to: string;
  /**
   * Keep the rest of the path after this prefix (V3-041): with `fromPrefix="/locations"` and
   * `to="/material-locations"`, /locations/counts/7?x=1 lands on /material-locations/counts/7?x=1.
   */
  fromPrefix?: string;
}> = ({ to, fromPrefix }) => {
  const location = useLocation();
  const rest =
    fromPrefix && location.pathname.startsWith(fromPrefix) ? location.pathname.slice(fromPrefix.length) : '';
  return <Navigate to={`${to}${rest}${location.search}${location.hash}`} replace />;
};

export default RedirectPreservingQuery;
